import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
function TranslateDialogViewModel(obs1, obs2, obs3, obs4, obs5) {
    var self = this;
    self.Language1 = ko.observable(obs1());
    self.Language2 = ko.observable(obs2());
    self.Language3 = ko.observable(obs3());
    self.Language4 = ko.observable(obs4());
    self.Language5 = ko.observable(obs5());
    self.ApplyValues = function () {
        obs1(self.Language1());
        obs2(self.Language2());
        obs3(self.Language3());
        obs4(self.Language4());
        obs5(self.Language5());
    };
    self.Open = function () {
        return Bao.get("Application/TranslateDialog", function (result) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: function () {
                        self.ApplyValues();
                        dialog.Close();
                    },
                    Enabled: ko.observable(true)
                }, {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: function () {
                        dialog.Close();
                    },
                    Enabled: ko.observable(true)
                }]);
            dialog.ViewModel(self);
            dialog.Template(result);
            dialog.Open();
        });
    };
}
export default TranslateDialogViewModel;